const Tooltip = {
  baseStyle: {
    borderRadius: 'small',
    zIndex: 9999,
    fontSize: 'md',
    py: '10px',
    px: '10px',
  },
};

export default Tooltip;
